export default __webpack_public_path__ + "static/media/6-ConnectionPage.625f7417.jpeg";